import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Link.module.scss';
import clsx from 'clsx';
const Link = ({ children, className, onClick, noLine }) => {
  return (
    <>
      <div className={clsx(styles.link, className, noLine && styles.linkNoLine)} onClick={onClick}>
        {children}
      </div>
    </>
  );
};

export default Link;
